import {privacyPolicyForPartners, privacyPolicyAtlantaURl} from "./api";
export const partners = [
    {
        id: 200,
        doc: privacyPolicyForPartners
    },
    {
        id: 205,
        doc: privacyPolicyForPartners
    },
    {
        id: 212,
        doc: privacyPolicyForPartners
    },
    {
        id: 209,
        doc: privacyPolicyForPartners
    },
    {
        id: 210,
        doc: privacyPolicyForPartners
    },
    {
        id: 211,
        doc: privacyPolicyForPartners
    },
    {
        id: 204,
        doc: privacyPolicyForPartners
    },
    {
        id: 207,
        doc: privacyPolicyForPartners
    },
    {
        id: 206,
        doc: privacyPolicyForPartners
    },
    {
        id: 208,
        doc: privacyPolicyForPartners
    },
    {
        id: 13,
        doc: privacyPolicyAtlantaURl
    },
]
